var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{attrs:{"width":_vm.content.attrs.colwidth,"rowspan":_vm.content.attrs.rowspan,"colspan":_vm.content.attrs.colspan}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }